export default __webpack_public_path__ + "static/media/hht2_ani_19.f0ac9c37.png";